import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
  IonSpinner,
  useIonToast,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import onboardPLNPlus from "../../../assets/img/icons/onboard_plnplus.svg";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  navigateCircle,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import BillingAddressForm from "../../../components/BillingAddressForm";
import SchedulingCalendarV2 from "../../../components/Scheduler/SchedulingCalendar/SchedulingCalendarV2";
import onboardReferral from "../../../assets/img/icons/onboard_referral.svg";

const PLNPlusReferralPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(
    Capacitor?.isNativePlatform() ? true : false,
  );
  const pageRef = useRef();

  const [user, setUser] = useState<any>(null);
  const [referralProgram, setReferralProgram] = useState<any>({
    name: "Give $20, Get $20",
    value: 2000,
  });
  const [store, setStore] = useState<any>({});
  const [onboardReferralCopied, setOnboardReferralCopied] = useState(false);
  const [onboardReferralShared, setOnboardReferralShared] = useState(false);

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    StorageUtils.get("user_customer").then((user) => {
      setUser(user);
    });

    StorageUtils.get("customer_store").then((store) => {
      setStore(store);
    });

    StorageUtils.get("user_referralProgram").then((referralProgram) => {
      if (referralProgram) {
        setReferralProgram(referralProgram);
      }
    });
  }, []);

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>Refer Friends & Family</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={"Refer Friends & Family"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="ion-padding">
          <div
            className="text-center flex h-full items-center"
            style={{
              height: "calc(100vh - 350px)",
            }}
          >
            <div className="mx-auto">
              <div className="rounded w-full min-h-[300px] max-h-[300px] sm:max-h-[350px] mt-[1rem] mb-[1.5rem] flex justify-center">
                <img
                  src={onboardReferral}
                  alt="PLN+"
                  className="w-auto h-full mx-auto max-h-[300px] sm:max-h-[350px] object-contain"
                />
              </div>

              <h2 className="font-[SourceSerif] font-medium text-2xl mb-[0.5rem]">
                Share The Love With {referralProgram?.name} 🙌
              </h2>

              <p className="" style={{ fontSize: 18 }}>
                Friends don't let friends eat healthy alone! You'll both receive
                a{" "}
                {StringUtils.centsToCurrency(referralProgram?.value)?.replace(
                  ".00",
                  "",
                )}{" "}
                credit when they sign up using your personal referral code.
              </p>
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() ? "web" : ""
          }`}
        >
          <IonButton
            disabled={onboardReferralCopied}
            onClick={() => {
              // Prompt for notifications

              const win: any = window;

              if (navigator.share !== undefined) {
                try {
                  navigator
                    .share({
                      title: `${
                        store?.operations?.storeOpening?.firstBillDate &&
                        moment().isAfter(
                          moment(
                            store?.operations?.storeOpening?.firstBillDate,
                          ),
                        )
                          ? "Join Me"
                          : "Become A Founding Member"
                      } At Project LeanNation!`,
                      text: `Let's tackle our health goals together at Project LeanNation! Use my signup link ${
                        store?.operations?.storeOpening?.firstBillDate &&
                        moment().isAfter(
                          moment(
                            store?.operations?.storeOpening?.firstBillDate,
                          ),
                        )
                          ? `to get started with me and get ${StringUtils.centsToCurrency(
                              referralProgram?.value,
                            )} off your first order`
                          : `to become a founding member with me & lock in extra savings`
                      }!`,
                      url: user?.referralCodeURL,
                    })
                    .then(() => {
                      console.log("Thanks for sharing!");

                      setOnboardReferralShared(true);
                    })
                    .catch((e) => {
                      console.log(e);
                    });
                } catch (e) {
                  console.error(e);
                }
              } else {
                navigator.clipboard.writeText(user?.referralCodeURL);

                setOnboardReferralCopied(true);
                setOnboardReferralShared(true);

                setTimeout(() => {
                  setOnboardReferralCopied(false);
                }, 1500);
              }
            }}
            expand="block"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            {onboardReferralCopied ? (
              "Copied!"
            ) : (
              <>
                {navigator.share !== undefined ? "Send" : "Copy"} Referral Code
                & Save{" "}
                {StringUtils.centsToCurrency(referralProgram?.value)?.replace(
                  ".00",
                  "",
                )}
              </>
            )}
          </IonButton>
          <IonButton
            onClick={async () => {
              next();
            }}
            expand="block"
            color="dark"
            fill="clear"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            {onboardReferralShared ? "Continue" : "Maybe Later"}
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default PLNPlusReferralPage;
